// 后端动态字段配置项
// 用于将后台返回的字段类型int值和前端文件名称对应起来
export const regulation = {
    // 普通输入框
    1: "input",
    // 普通文本域
    2: 'textArea',
    // 普通单选下拉选择框
    3: 'select',
    // 普通复选下拉选择框
    4: 'select',
    // 日期选择器
    5: 'datePicker',
    // **********************以下是前端和后端协商规定的固定类型，用于展示不同的组件***********************************//
    6: 'dangerDisposer',  //危险处置人
    7: 'douYinLink',  //抖音链接
    8: 'uploadRecord',  //备案表
    9: 'attachment',  //附件
    10: 'unitSelect',  //主责单位
    11: 'confirmBox',  //确认框
    12: 'userSearchSelect', //用户搜索选择框
};